import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://wqivipbljcrbszvczqrv.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndxaXZpcGJsamNyYnN6dmN6cXJ2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzczNDM4MDEsImV4cCI6MjA5MjkxOTgwMX0.w9R9QNihkJE7iKQZfsHzDYPQMusgMnO-mqybmbtk9Nw'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)